/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */
/* eslint-disable radix */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-return-assign */
/* eslint-disable operator-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import * as Yup from 'yup';
import {
  TextField,
  FormGroup,
  Grid,
  FormControl,
  DialogContent,
  DialogContentText,
  Card,
  CardContent,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import 'dayjs/locale/pt';
import './styles.css';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import NumberFormat from 'react-number-format';
import { useStyles } from '../../components/Styles';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import HandleProductions from './handleProductions';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { setSnackbar } from '../../redux/snackbar';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import { setSelectedCycle } from 'redux/selectedCycle';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import { POND_STATUS_CYCLE } from 'utils/consts';
import { labelField } from 'utils';
import CycleCodeService from 'services/CycleCodeService';
import { useDependencyInjection } from 'hooks/useDependencyInjection';

function Harvest() {
  const location = useLocation();
  const [selectedCylePond, handleCyclePond] = useState(null);
  const [cycles, setCycles] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [selectedDate, handleDateChange] = useState(new Date());
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();
  const disable = useSelector((state) => state.disable.disable);
  const typeProperty = useSelector((state) => state.typeProperty.typeProperty);
  const error = Error();
  const [openSales, setOpenSales] = useState(false);
  const [openDialogPlans, setOpenDialogPlans] = useState(false);
  const [pondsIsNull, setPondsIsNull] = useState(false);
  const [dadosSales, setDadosSales] = useState([]); // Dados compartilhados de Vendas
  const [valueTotal, setValueTotal] = useState(0);
  // const [pondCycles, setPondCycles] = useState([]);
  const [alter, setAlter] = useState(true);
  const [harvestId, setHarvestId] = useState();
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );

  const formik = useFormik({
    initialValues: {
      cycle: '',
      production: '',
      quantity: '',
      date: '',
      cycles: [],
      sales: [],
    },
    // validationSchema: Yup.object({
    //   status: Yup.string().required('Campo Obrigatório'),
    // }),
    onSubmit: (values) => {
      if (typeProperty === 'freemium' && openDialogPlans) {
        return null;
      }
      if (values.cycles.length === 0) {
        pondsIsNull[1](true);
        return false;
      }
      // dispatch(setLoading(true));
      values.date = selectedDate.toUTCString();
      request(values);
    },
  });

  function updatecycles(cycles) {
    formik.setFieldValue('cycles', cycles);
  }

  const { success } = useDependencyInjection();

  useEffect(() => {
    if (location.state !== undefined) {
      id = location.state.id;
    }
  }, [location]);

  useEffect(() => {
    async function load() {
      setOpenProgress(true);

      const cycle_ = await api.get('/cycles');
      setCycles(cycle_.data);

      const statusCycle = [];
      cycle_.data.map((item) => {
        if (item.status === POND_STATUS_CYCLE.CULTIVANDO) {
          statusCycle.push(item);
        }
        return null;
      });

      if (id) {
        const harvest = await api.get(`/harvests/${id}`);
        formik.setValues(harvest.data);
        setDadosSales(harvest.data.sales);

        handleCyclePond(harvest.data.cycle);

        handleDateChange(new Date(harvest.data.date));

        if (location.state !== undefined) {
          id = null;
          formik.setFieldValue('id', null);
        }
      }
      setOpenProgress(false);
    }
    load();
  }, []);

  async function request(data) {
    dispatch(setDisable(true));

    data.cycles.forEach(async (cycle) => {
      if (cycle.want_to_finish === true) {
        try {
          await api.put(`/cycles/${cycle.id}`, {
            ...cycle,
            status: 'Concluído',
            end: new Date(),
          });
          const updatedCurrentCycle = await CycleCodeService.currentCycleById(
            selectedCycle.id
          );
          dispatch(setSelectedCycle(updatedCurrentCycle));
        } catch (err) {
          error();
        }
      }
    });

    try {
      if (id) {
        await api.put(`/harvests/${id}`, { ...data }).then(() => {
          if (
            typeProperty !== 'freemium' &&
            formik.values.status === 'concluída'
          ) {
            dispatch(
              setSnackbar(true, 'success', 'Ação Submetida com Sucesso!')
            );
          }
          setOpenSales(false);
          history.push('/harvests');
        });
      } else {
        await api.post('/harvests', { ...data }).then((request) => {
          setHarvestId(request.data.id);
          if (
            typeProperty !== 'freemium' &&
            formik.values.status === 'concluída'
          ) {
            setOpenSales(true);
          }
          success();
          history.push('/harvests');
        });
      }
    } catch (err) {
      error();
    } finally {
      dispatch(setDisable(false));
      dispatch(setLoading(false));
      if (formik.values.status === 'pendente') {
        dispatch(setSnackbar(true, 'success', 'Ação Submetida com Sucesso!'));
        history.push('/harvests');
      }
    }
  }

  // updates values from callback
  function updateValueTotal(options) {
    let valTotal = 0;
    options.map((cycle) => (valTotal += parseInt(cycle.production)));
    setValueTotal(valTotal);
  }

  const handleCloseSales = () => {
    setOpenSales(false);
    dispatch(setSnackbar(true, 'success', 'Ação Submetida com Sucesso!'));
    history.push('/harvests');
  };

  function handleStatusSales() {
    const data = {
      cycles: [...formik.values.cycles],
      dateSale: formik.values.date,
      productionSale: formik.values.production,
      date: formik.values.date,
    };
    if (typeProperty === 'freemium') {
      setOpenDialogPlans(true);
    } else {
      let hId = null;
      if (id !== undefined) {
        hId = id;
      }
      setOpenSales(false);
      history.push({
        pathname: '/sale',
        state: { harvestId: hId || harvestId, harvestData: data },
      });
    }
  }

  function handleClosePlans() {
    setOpenDialogPlans(false);
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  useEffect(() => {
    updateValueTotal(formik.values.cycles);
  }, [alter]);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress && <Progress />}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados da Despesca
              <HtmlTooltip
                title="Nessa tela é possível registrar uma despesca envolvendo vários viveiros e suas respectivas produções."
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>

            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={id ? 6 : 4}>
                  <FormGroup>
                    <LocalizationProvider
                      dateAdapter={DateFnsUtils}
                      adapterLocale={deLocale}
                    >
                      <DatePicker
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        label={
                          <div>
                            Data de Despesca
                            <HtmlTooltip
                              title="Data em que a despesca foi realizada"
                              placement="right"
                              arrow
                            >
                              <HelpIcon color="primary" fontSize="inherit" />
                            </HtmlTooltip>
                          </div>
                        }
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage="Data Inválida"
                        value={selectedDate}
                        onChange={(date) => handleDateChange(date)}
                        format="dd/MM/yyyy"
                        // inputFormat="DD/MM/YYYY"
                        renderInput={(params) => <TextField {...params} />}
                        fullWidth
                      />
                    </LocalizationProvider>
                  </FormGroup>
                </Grid>

                <Grid item xs={12} md={id ? 6 : 4}>
                  <FormGroup>
                    <NumberFormat
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="production"
                      label={
                        <div>
                          {formik.values.status == 'pendente'
                            ? 'Previsão da Produção Total (em kg)'
                            : 'Produção Total (em kg)'}
                          <HtmlTooltip
                            title={
                              <>
                                Quantidade de animais despescados em quilos
                                (Opcional)
                              </>
                            }
                            placement="right"
                            arrow
                          >
                            <HelpIcon color="primary" fontSize="inherit" />
                          </HtmlTooltip>
                        </div>
                      }
                      variant="outlined"
                      disabled
                      name="production"
                      thousandSeparator="."
                      decimalSeparator=","
                      fullWidth
                      decimalScale={0}
                      value={valueTotal}
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          production: values.floatValue,
                        });
                      }}
                      onBlur={formik.handleBlur}
                      customInput={TextField}
                      error={
                        !!(
                          formik.touched.production && formik.errors.production
                        )
                      }
                      helperText={
                        formik.touched.production &&
                        formik.errors.production &&
                        formik.errors.production
                      }
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs>
                  <FormGroup>
                    <FormControl>
                      <HandleProductions
                        att={setAlter}
                        alter={alter}
                        supply_id={id}
                        temporaryDisabled={!!id}
                        options={formik.values.cycles}
                        callback={updatecycles}
                        pondsIsNull={pondsIsNull}
                        setPondsIsNull={setPondsIsNull}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
              </Grid>
            </CardContent>
          </div>

          <Dialog
            open={openDialogPlans}
            onClose={handleClosePlans}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Opção bloqueada</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Para ter acesso ilimitado a todo nosso sistema, assine um de
                nossos planos ou tenha acesso a todo nosso sistema por tempo
                limitado atráves do teste de 30 dias.
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ padding: '1rem' }}>
              <Button
                variant="outlined"
                onClick={handleClosePlans}
                style={{
                  border: '1px solid red',
                  color: 'red',
                }}
              >
                Não
              </Button>
              <Button
                autoFocus
                onClick={handleClosePlans}
                style={{
                  backgroundColor: '#0267C1',
                  color: 'white',
                }}
              >
                Sim
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openSales}
            onClose={handleCloseSales}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Deseja realizar vendas deste viveiro?
            </DialogTitle>
            <DialogActions style={{ padding: '1rem' }}>
              <Button
                variant="outlined"
                onClick={handleCloseSales}
                style={{
                  border: '1px solid red',
                  color: 'red',
                }}
              >
                Não
              </Button>
              <Button
                onClick={handleStatusSales}
                style={{
                  backgroundColor: '#0267C1',
                  color: 'white',
                }}
              >
                Sim
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Deseja realizar uma venda dessa despesca?
            </DialogTitle>
            <DialogActions style={{ padding: '1rem' }}>
              <Button
                variant="outlined"
                onClick={handleClose}
                style={{
                  border: '1px solid red',
                  color: 'red',
                }}
              >
                Não
              </Button>
              <Button
                onClick={handleStatusSales}
                style={{
                  backgroundColor: '#0267C1',
                  color: 'white',
                }}
              >
                Sim
              </Button>
            </DialogActions>
          </Dialog>

          <GroupButton
            deleteRoute="/harvests/"
            routeDelete="/harvests"
            returnRoute="/harvests"
            id={id}
            disable={disable}
            message="A exclusão dessa despesca pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Harvest;
